import { t } from '@lingui/core/macro';
import { CommonMetadataAllowedValuesFilter } from './MetadataAllowedValuesFilter';
export const processingOfPersonalDataFilterLabel = () => t({
    message: 'Processing of personal data',
    comment: 'Insights filter: Processing of personal data',
});
export function ProcessingOfPersonalDataFilter() {
    return (<CommonMetadataAllowedValuesFilter name="ProcessingOfPersonalData" field="metadataDocumentProcessingOfPersonalData" label={processingOfPersonalDataFilterLabel()}/>);
}
